export const translateThumbs = (elements: Element[], offsets: ThumbOffsets) => {
  elements.forEach((element, index) => {
    translate(element, offsets[index].x, offsets[index].y)
  })
}

const translate = (element: Element, x: number, y: number) => {
  ;(element as HTMLDivElement).style.transform = `translate(${x}px, ${y}px)`
}

type ThumbOffsets = { x: number; y: number }[]
